"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoardSurfaceConfig = getBoardSurfaceConfig;
const models_1 = require("@creature-chess/models");
function getBoardSurfaceConfig(input) {
    const isMatch = input.phase === models_1.GamePhase.READY || input.phase === models_1.GamePhase.PLAYING;
    const isInteractive = input.spectatingId === null;
    return {
        isMatch,
        isPreparing: !isMatch,
        isInteractive,
        boardDraggable: isInteractive && !isMatch,
        benchDraggable: isInteractive,
    };
}
